import { Adapter as r } from "../../../adapter.js";
import { CustomerConfigurationModel as t } from "./customerConfiguration.model.js";
class n extends r {
  adapt(e) {
    var o;
    return new t(
      e.source,
      e.status,
      {
        custom: ((o = e.tags) == null ? void 0 : o.custom) ?? []
      },
      e.need_verification ?? !1
    );
  }
  serialize(e) {
  }
}
export {
  n as CustomerConfigurationAdapter
};
//# sourceMappingURL=customerConfiguration.adapter.js.map
